import { render, staticRenderFns } from "./feature-card.vue?vue&type=template&id=ff7f7154&scoped=true"
import script from "./feature-card.vue?vue&type=script&lang=js"
export * from "./feature-card.vue?vue&type=script&lang=js"
import style0 from "./feature-card.vue?vue&type=style&index=0&id=ff7f7154&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7f7154",
  null
  
)

export default component.exports